import { useEffect, useState } from 'react';
import { withBackendPath } from '../config/api';

/**
 * The signed-in user (MSAL session), or null for participants on a PIN or a
 * device. The session cookie is httpOnly, so the only way to know is to ask
 * /auth/me — cheap, and 401 when there is no session. Facilitator-only
 * controls hang off this: `const { user, signedIn, checked } = useAuthUser()`.
 */
export default function useAuthUser() {
  const [user, setUser] = useState(null);
  const [checked, setChecked] = useState(false);
  useEffect(() => {
    let cancelled = false;
    fetch(withBackendPath('/auth/me'), { credentials: 'include' })
      .then((r) => (r.ok ? r.json() : null))
      .then((u) => { if (!cancelled) { setUser(u || null); setChecked(true); } })
      .catch(() => { if (!cancelled) { setUser(null); setChecked(true); } });
    return () => { cancelled = true; };
  }, []);
  return { user, signedIn: Boolean(user), checked };
}
